import { useEffect, useState } from "react";
import { useInterval } from "@tk-events/fw";
export var isMember = window.dataLayer[0]["Registrant Type"] !== "Non-Member";
export var useDate = function () {
    var now = new Date();
    var _a = useState(now.getUTCFullYear()), year = _a[0], updateYear = _a[1];
    var _b = useState(now.getUTCMonth()), month = _b[0], updateMonth = _b[1];
    var _c = useState(now.getUTCDate()), date = _c[0], updateDate = _c[1];
    // Really this should set up setTimeouts to update but I'M IN A RUSH
    useInterval(function () {
        var newNow = new Date();
        updateYear(newNow.getUTCFullYear());
        updateMonth(newNow.getUTCMonth());
        updateDate(newNow.getUTCDate());
    }, 1000 * 60 * 5);
    return { year: year, month: month, date: date };
};
export var useTime = function () {
    var now = new Date();
    var _a = useState(now.getUTCHours()), hours = _a[0], updateHours = _a[1];
    var _b = useState(now.getUTCMinutes()), minutes = _b[0], updateMinutes = _b[1];
    var _c = useState(now.getUTCSeconds()), seconds = _c[0], updateSeconds = _c[1];
    // Really this should set up setTimeouts to update but I'M IN A RUSH
    useInterval(function () {
        var newNow = new Date();
        updateHours(newNow.getUTCHours());
        updateMinutes(newNow.getUTCMinutes());
        updateSeconds(newNow.getUTCSeconds());
    }, 5000);
    return { hours: hours, minutes: minutes, seconds: seconds };
};
export var useDateTime = function (resolution) {
    if (resolution === void 0) { resolution = "minute"; }
    var _a = useState(new Date()), time = _a[0], updateTime = _a[1];
    var timeout = resolution === "day" ? 86400000
        : resolution === "hour" ? 3600000
            : resolution === "minute" ? 60000
                : 1000; // 1 second
    useEffect(function () { window.setInterval(function () { updateTime(new Date()); }, timeout); }, [resolution]);
    return time;
};
export var useDayOfEvent = function () {
    var date = useDate().date;
    // Event starts on the 25th which is day 1, so we
    // subtract 24 from the date, and then modulo 5
    return date % 5 + 1;
};
